import axios from 'axios';

async function associateToken(companyId, socialNetwork, data) {
  const response = await axios.put(`/companies/${companyId}/${socialNetwork}/associate`, data);

  return response.data;
}

async function revokeToken(companyId, socialNetwork) {
  const response = await axios.put(`/companies/${companyId}/${socialNetwork}/revoke`);

  return response.data;
}

const socialNetworkService = {
  associateToken,
  revokeToken,
}

export default socialNetworkService;
